import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cm-empty-title',
  templateUrl: './empty-title.component.html',
  styleUrls: ['./empty-title.component.css']
})
export class EmptyTitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/empty/empty-title/empty-title.component.ts